
import { Vue, Component } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { TableHeaderConfig } from '@/views/interfaces/vuetify/table.interface';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import RemoveServerDialog from '@/components/dialogs/server/RemoveServerDialog.vue';

@Component({
  mixins: [Themeable],
  inject: [
    'serverRepository',
  ],
  components: {
    RemoveServerDialog,
  },
})
export default class AllServers extends Vue {
  public readonly serverRepository!: ServerRepositoryInterface;

  public loading: boolean = true;
  public search: string = '';
  public headers: TableHeaderConfig[] = [
    { text: 'Server/Hostname', value: 'hostname' },
    { text: 'Type', value: 'type' },
    { text: 'Services', value: 'services' },
    { text: 'IPs', value: 'config.ips' },
    { text: 'Status', value: 'status' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  public servers: ServerInterface[] = [];

  public deleteServerDialogData: ServerInterface | false = false;
  public deleteServerDialog: string = '';

  public async created(): Promise<void> {
    await this.initialize();
  }

  public async initialize(): Promise<void> {
    try {
      this.loading = true;
      this.servers = await this.serverRepository.getAllServers();
    } catch (err) {
      this.$errorDialog.show(`Failed to retrieve servers. Error: ${(err as Error).message}`)
    } finally {
      this.loading = false;
    }
  }

  public async addServer(): Promise<void> {
    this.$router.push({ name: 'server_add' });
  }

  public async editServer(server: ServerInterface): Promise<void> {
    await this.$router.push({ name: 'server_edit', params: { server: server._id } })
  }

  public async removeServerPrompt(server: ServerInterface): Promise<void> {
    this.deleteServerDialog = 'remove-server-dialog';
    this.deleteServerDialogData = server;
  }

  public async removeServer(server: ServerInterface): Promise<void> {
    await this.serverRepository.removeServer(server._id);
    this.$successDialog.show(`Server ${server._id} has been removed.`);
    this.servers = await this.serverRepository.getAllServers();
  }
}

